import { useState, useCallback, useEffect, ChangeEvent } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { fetchDescriptionSearchBox } from '@reducers/keyword/thunk/optimizationThunk';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';

const SearchBox = ({
  selectedAppObj, // request 시 필요
  tabType, // request 시 필요 OptimizationTabObjList 의 value
  limitLength, // 50 숫자
  placeHolder, // 문자열
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [text, setText] = useState('');

  // 쓰로틀링 관련 state
  const [timeoutId, setTimeoutId] = useState(null);
  const [requestFlag, setRequestFlag] = useState(true);

  // timeout 해제처리
  useEffect(() => {
    if (requestFlag) {
      clearTimeout(timeoutId);
    }
  }, [requestFlag]);

  const onChangeTextHandler = useCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    if (value.trim().length <= limitLength) {
      setText(value);
    } else {
      alert(`Restricted within ${limitLength} letters`);
    }
  }, []);

  const onClickCopyTextHandler = useCallback(() => {
    if (text.trim().length === 0) {
      alert('you have to write on it first!');
    } else {
      alert(`"${text}" Copied Complete!`);
    }
  }, [text]);

  const onClickRequestTextHandler = useCallback(async () => {
    console.log('selectedAppObj: ', selectedAppObj);
    console.log('tabType: ', tabType);
    console.log('requestFlag: ', requestFlag);
    //requestFlag true 일때 동작
    if (requestFlag) {
      // 쓰로틀링 로직
      setRequestFlag(false);
      const _id = setTimeout(() => {
        setRequestFlag(true);
      }, 5000);
      setTimeoutId(_id);

      // 요청은 디바운스 처리
      _.debounce(async () => {
        const { data, status } = await axiosDummyInstance.get(
          '/api/keyword/keywordOptimizationSearchBoxGetButton.json',
          { params: { appId: selectedAppObj.appId, tabType } }
        );
        if (status === 200) {
          const { result } = data;
          setText(result);
        }
      }, 1000)();
    } else {
      alert(`Please wait!
      Data is being retried.`);
    }
  }, [selectedAppObj, tabType, requestFlag]);

  const onClickTestHandler = useCallback(() => {
    if (text.trim().length === 0) {
      alert('you have to write on it first!');
    } else {
      dispatch(fetchDescriptionSearchBox({ userId: 'ss', tabType: tabType, test: text }));
    }
  }, [text, selectedAppObj, tabType, dispatch, fetchDescriptionSearchBox]);

  return (
    <div className="title-add-box multiple-lines">
      <div className="title-add-txt">
        <span className="title-add-tit">Test a new Description</span>
        <span className="title-add-num">
          <i className="title-add-max">{text.length}</i>/{limitLength}
        </span>
      </div>
      <label className="ipt">
        <textarea
          id="story"
          name="story"
          rows={6}
          cols={33}
          className="textarea"
          value={text}
          onChange={onChangeTextHandler}
          placeholder={placeHolder}
        ></textarea>
      </label>
      <div className="title-add-btn">
        <button type="button" className="btn-s line myapp-title" onClick={onClickRequestTextHandler}>
          <span>Get My App Description</span>
        </button>
        <CopyToClipboard text={text}>
          <button type="button" className="btn-ico-single line copy" onClick={onClickCopyTextHandler}>
            <span className="blind">copy</span>
          </button>
        </CopyToClipboard>
        <button type="button" className="btn-s size-m" onClick={onClickTestHandler}>
          Analyze
        </button>
      </div>
    </div>
  );
};

export default SearchBox;
